<template>
    <img v-if="organization.logo_url" :src="organization.logo_url" :class="[!removeBaseClasses ? baseClasses : '', dynamicClasses, additionalClasses]">
    <div v-else :class="[!removeBaseClasses ? baseClasses : '', dynamicClasses, additionalClasses]">
        {{ organization.acronym }}
    </div>
</template>

<script>
export default {
    props: {
        organization: {
            type: Object,
            required: true,
        },
        size: {
            default: 16,
        },
        removeBaseClasses: {
            type: Boolean,
            default: false,
        },
        additionalClasses: {
            type: String,
            default: '',
        },
    },

    computed: {
        baseClasses() {
            const classes = 'inline-flex justify-center rounded-full';
            if (!this.organization.logo_url) {
                return `${classes} items-center text-white`;
            }
            return classes;
        },

        dynamicClasses() {
            const dimensions = this.getDimensions();
            if (!this.organization.logo_url) {
                const color = this.getColor();
                const textSize = this.getTextSize();
                return `${color} ${dimensions} ${textSize}`;
            }

            return `${dimensions}`;
        },
    },

    methods: {
        getDimensions() {
            let dimensions;
            switch (true) {
                case (this.size === '32px'):
                    dimensions = 'h-32px w-32px';
                    break;
                case (this.size === '36px'):
                    dimensions = 'h-36px w-36px';
                    break;
                case (this.size === 12):
                    dimensions = 'h-12 w-12';
                    break;
                default:
                    dimensions = 'h-16 w-16';
                    break;
            }
            return dimensions;
        },

        getColor() {
            const colors = ['bg-primary-500', 'bg-success-500', 'bg-info-500', 'bg-warning-500', 'bg-danger-500'];
            let number = this.organization.acronym.charCodeAt(0);
            if (!isNaN(this.organization.acronym.charCodeAt(1))) {
                number += this.organization.acronym.charCodeAt(1);
            }

            return colors[number % colors.length];
        },

        getTextSize() {
            let textSize;
            switch (true) {
                case (this.size === '32px'):
                    textSize = 'text-sm';
                    break;
                case (this.size === '36px'):
                    textSize = 'text-sm';
                    break;
                case (this.size === 12):
                    textSize = 'text-lg';
                    break;
                default:
                    textSize = 'text-2xl';
                    break;
            }
            return textSize;
        },
    },
};
</script>
